import { LineChart } from "@mui/x-charts/LineChart";
import { Text } from "../../../../components/common/typography";
import type { TimeSeriesBucketDto } from "../../hooks/useAdminLoyaltyAnalytics";

const COLORS = {
  issued: "#34C6A7",
  redeemed: "#05A7B8",
  expired: "#CF0505",
} as const;

interface Props {
  timeSeries: TimeSeriesBucketDto[];
  granularity: "week" | "month";
}

function formatLabel(iso: string, granularity: "week" | "month"): string {
  const d = new Date(iso);
  if (granularity === "month") {
    return d.toLocaleDateString(undefined, { month: "short", year: "2-digit" });
  }
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function LoyaltyTrendChart({ timeSeries, granularity }: Props) {
  if (timeSeries.length === 0) {
    return (
      <div className="flex h-72 items-center justify-center">
        <Text variant="bodySm" tone="muted">No activity in this date range.</Text>
      </div>
    );
  }

  const xLabels = timeSeries.map((b) => formatLabel(b.period, granularity));

  return (
    <div className="h-72">
      <LineChart
        height={288}
        xAxis={[{ data: xLabels, scaleType: "point" }]}
        series={[
          {
            data: timeSeries.map((b) => b.pointsIssued),
            label: "Issued",
            color: COLORS.issued,
            showMark: timeSeries.length <= 16,
          },
          {
            data: timeSeries.map((b) => b.pointsRedeemed),
            label: "Redeemed",
            color: COLORS.redeemed,
            showMark: timeSeries.length <= 16,
          },
          {
            data: timeSeries.map((b) => b.pointsExpired),
            label: "Expired",
            color: COLORS.expired,
            showMark: timeSeries.length <= 16,
          },
        ]}
        grid={{ horizontal: true }}
        slotProps={{
          legend: {
            position: { vertical: "top", horizontal: "end" },
          },
        }}
      />
    </div>
  );
}
